module.exports = __webpack_public_path__ + "static/media/BC_Timeless_Piazza_Bordeaux.7a26b64b.png";